import { parse, isValid } from 'date-fns'

export function parseDate(dateString) {
	if (!dateString) {
		return new Date()
	}

	// Handle MM-dd-yyyy format
	const formattedDate = parse(dateString, 'MM-dd-yyyy', new Date())

	// If parsing failed, try other common formats
	if (!isValid(formattedDate)) {
		// Try MM/dd/yyyy format
		const altDate = parse(dateString, 'MM/dd/yyyy', new Date())
		if (isValid(altDate)) {
			return altDate
		}

		// Try yyyy-MM-dd format
		const isoDate = parse(dateString, 'yyyy-MM-dd', new Date())
		if (isValid(isoDate)) {
			return isoDate
		}

		// If all parsing fails, return current date
		console.warn(`Failed to parse date: ${dateString}`)
		return new Date()
	}

	return formattedDate
}
